import { useEffect } from 'react'
import { INVITE_CODE_STORAGE } from '@/utils/constants'
import { useRouter } from 'next/router'

const useSetFormInviteCode = ({ form }: { form: any }) => {
  const router = useRouter()
  const { query } = router

  useEffect(() => {
    const curInviteCode = query.f || localStorage.getItem(INVITE_CODE_STORAGE) || ''
    form.setFieldValue('invite_code', curInviteCode)
  }, [query.f, form])
}

export default useSetFormInviteCode
